import { type StepperDialogConfig } from '@ics-portal/guardian';
import { ProjectFormDetailsStep } from './components/ProjectFormDetails/ProjectFormDetailsStep';
import { ProjectFormRequirementsStep } from './components/ProjectFormRequirements/ProjectFormRequirementsStep';
import { ProjectFormStandardsStep } from './components/ProjectFormStandards/ProjectFormStandardsStep';
import { ProjectFormCustomerStep } from './components/ProjectFormCustomer/ProjectFormCustomerStep';

type StepConfig = StepperDialogConfig['steps'][0];

export function getProjectFormSteps(isEditMode?: boolean): StepConfig[] {
    return [
        {
            title: 'Information',
            content: <ProjectFormDetailsStep isEditMode={isEditMode} />,
        },
        {
            title: 'Requirement',
            content: <ProjectFormRequirementsStep isEditMode={isEditMode} />,
        },
        {
            title: 'Standards',
            content: <ProjectFormStandardsStep isEditMode={isEditMode} />,
        },
        {
            title: 'Customer',
            content: <ProjectFormCustomerStep isEditMode={isEditMode} />,
        },
    ];
}
